import { useMediaQuery } from "react-responsive";
import PcHome from "./PcHome";
import MobileHome from "./MobileHome";

export function Pc({ children }) {
  const isPc = useMediaQuery({
    query: "(min-width: 551px)",
  });

  return <>{isPc && children}</>;
}

export function Mobile({ children }) {
  const isMobile = useMediaQuery({
    query: "(max-width: 550px)",
  });

  return <>{isMobile && children}</>;
}

const Home = () => {
  return (
    <>
      <Pc>
        <PcHome />
      </Pc>
      <Mobile>
        <MobileHome />
      </Mobile>
    </>
  );
};

export default Home;
